import React from "react";
import { PackagePlus } from "lucide-react";
import { NonOrderProductCheckIn } from "src/types";
import { NonOrderProductCheckInTable } from "src/components/tables";
import { CollapsibleSection } from "src/components/ui/collapsible";

interface NonOrderProductCheckInsSectionProps {
  nonOrderProducts: NonOrderProductCheckIn[];
  initiallyOpen?: boolean;
  withCollapsible?: boolean;
}

const NonOrderProductCheckInsSection: React.FC<NonOrderProductCheckInsSectionProps> = ({
  nonOrderProducts,
  initiallyOpen = true,
  withCollapsible = true
}) => {
  if (!nonOrderProducts.length) {
    return null;
  }

  const content = (
    <div className="p-6 space-y-4">
      <div className="space-y-2">
        <p className="text-sm text-secondary-600">
          These products were received without a matching purchase order. Review and reconcile with operations before
          approving inventory updates.
        </p>
      </div>
      <NonOrderProductCheckInTable nonOrderProductCheckIns={nonOrderProducts} />
    </div>
  );

  if (!withCollapsible) {
    return (
      <section className="rounded-2xl border border-secondary-200 bg-white shadow-soft">
        <div className="flex items-center gap-2 border-b border-secondary-100 px-6 py-4">
          <PackagePlus className="h-5 w-5 text-primary-600" />
          <h3 className="text-base font-semibold text-secondary-900">Non-order Product Check-ins</h3>
        </div>
        {content}
      </section>
    );
  }

  return (
    <div className="bg-white border border-secondary-200 rounded-xl shadow-soft overflow-hidden">
      <CollapsibleSection
        initiallyOpen={initiallyOpen}
        title={
          <h3 className="text-lg font-semibold text-secondary-800 flex items-center">
            <PackagePlus className="w-5 h-5 mr-2 text-primary-600" />
            Non-order Product Check-ins
          </h3>
        }
      >
        {content}
      </CollapsibleSection>
    </div>
  );
};

export { NonOrderProductCheckInsSection };
